<script lang="tsx">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return () => (
      <div class="ark-ui-table-empty-header">
        <span>-</span>
      </div>
    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-empty-header {
  position: relative;
  align-items: center;
  box-sizing: border-box;
  height: 48px;
  padding: 16px;
  span {
    opacity: 0 !important;
    user-select: none !important;
    pointer-events: none !important;
  }
}
</style>
